import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  SupplierBuyerNoticeSummaryQuery,
  SupplierBuyerNoticeSummaryRequest,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const supplierBuyerNoticeSummaryQuery = graphql(`
  query supplierBuyerNoticeSummary(
    $opportunityId: String!
    $searchRequest: SupplierBuyerNoticeSummaryRequest!
  ) {
    opportunity(id: $opportunityId) {
      supplierBuyerNoticeSummary(SupplierBuyerNoticeSummaryRequest: $searchRequest) {
        supplier {
          name
          id
        }
        allAwards {
          totalCount
          totalValue
        }
        similarAwards {
          totalCount
          totalValue
        }
      }
    }
  }
`);

export type SupplierBuyerNoticeSummary =
  SupplierBuyerNoticeSummaryQuery["opportunity"]["supplierBuyerNoticeSummary"];

export function useSupplierBuyerNoticeSummary(
  opportunityId: string,
  searchRequest: SupplierBuyerNoticeSummaryRequest,
  options?: UseQueryOptions<
    SupplierBuyerNoticeSummaryQuery,
    unknown,
    SupplierBuyerNoticeSummaryQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["opportunity", opportunityId, "supplierBuyerNoticeSummary", searchRequest],
    supplierBuyerNoticeSummaryQuery,
    [{ opportunityId, searchRequest }],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );

  return {
    data: data?.opportunity.supplierBuyerNoticeSummary,
    ...rest,
  };
}
